"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const _ = require("lodash");
exports.Select = (props) => {
    return React.createElement("select", { onChange: e => props.onChange(e.target.value), value: props.value }, _.toPairs(props.values).map(entry => React.createElement("option", { key: entry[0], value: entry[0] }, entry[1])));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Select.tsx
// module id = 73
// module chunks = 0 1